// Main Variables
// --------------------------------------------------------

export const header = document.querySelector('.header');
export const hero = document.querySelector('.animated-page-head');
export const heroHeight = !!hero ? hero.offsetHeight : !!header ? header.offsetHeight : 0;
export const mobileMenuState = {
  isOpened: false,
};
export const progressBar = document.querySelector('.progress-bar');
export const scrollTopBtn = document.querySelector('.scroll-top-btn');
